import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <>
      <SEO
        title="Terms and Conditions"
        description="Read AdOnRoads' terms and conditions for using our billboard advertising marketplace."
      />

      <div className="pt-24 pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-secondary mb-6">Terms and Conditions</h1>
          <p className="text-gray-600 mb-8">Effective Date: January 1, 2025</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700">
                By accessing and using AdOnRoads.com (the "Platform"), you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use the Platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">2. Beta Program</h2>
              <p className="text-gray-700 mb-4">
                AdOnRoads is currently in Beta testing phase. By participating in the Beta:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>You acknowledge that the Platform may contain bugs, errors, or incomplete features</li>
                <li>Features and functionality may change without notice</li>
                <li>Data may be reset or modified during the Beta period</li>
                <li>Beta access may be terminated at any time at AdOnRoads' discretion</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">3. User Accounts</h2>
              <p className="text-gray-700 mb-4">
                When you create an account with us:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>You must provide accurate, complete, and current information</li>
                <li>You are responsible for maintaining the confidentiality of your account credentials</li>
                <li>You are responsible for all activities that occur under your account</li>
                <li>You must notify us immediately of any unauthorized use of your account</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">4. Booking and Payment</h2>
              <p className="text-gray-700 mb-4">
                When making a booking through AdOnRoads:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>All bookings are subject to availability and confirmation</li>
                <li>Payment must be completed before the booking is confirmed</li>
                <li>Prices are displayed in INR or USD and include applicable platform fees</li>
                <li>Additional charges may apply for special requests or services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">5. Billboard Listings</h2>
              <p className="text-gray-700 mb-4">
                For agencies listing billboards on our Platform:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>You must have the legal right to list and rent the billboards</li>
                <li>All listing information must be accurate and up-to-date</li>
                <li>You must honor all confirmed bookings</li>
                <li>You are responsible for billboard maintenance and campaign execution</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">6. Prohibited Activities</h2>
              <p className="text-gray-700 mb-4">
                Users are prohibited from:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Using the Platform for illegal purposes</li>
                <li>Posting false, misleading, or fraudulent content</li>
                <li>Attempting to gain unauthorized access to the Platform</li>
                <li>Interfering with the proper functioning of the Platform</li>
                <li>Circumventing payment or booking procedures</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">7. Intellectual Property</h2>
              <p className="text-gray-700">
                All content on the Platform, including text, graphics, logos, and software, is the property of AdOnRoads or its licensors and is protected by intellectual property laws. Users may not reproduce, distribute, or create derivative works without explicit permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">8. Limitation of Liability</h2>
              <p className="text-gray-700">
                AdOnRoads acts as a marketplace connecting billboard owners and advertisers. We are not responsible for the quality, safety, or legality of billboard listings, the accuracy of user content, or the ability of users to complete transactions. Use of the Platform is at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">9. Governing Law</h2>
              <p className="text-gray-700">
                These Terms and Conditions are governed by the laws of India. Any disputes arising from these terms or use of the Platform shall be subject to the exclusive jurisdiction of courts in Pune, Maharashtra, India.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">10. Changes to Terms</h2>
              <p className="text-gray-700">
                AdOnRoads reserves the right to modify these Terms and Conditions at any time. We will notify users of significant changes via email or Platform notification. Continued use of the Platform after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">11. Contact</h2>
              <p className="text-gray-700">
                For questions about these Terms and Conditions, please contact us at{' '}
                <a href="mailto:support@adonroads.com" className="text-accent hover:underline">
                  support@adonroads.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPage;
